module.exports = __webpack_public_path__ + "static/media/GCFLogo.f21ccaac.png";